module.exports = __webpack_public_path__ + "img/products-fabrixai-thumbnail.dfe21e75.jpg";